"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../locale/index");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Registry = /*#__PURE__*/function () {
  function Registry() {
    _classCallCheck(this, Registry);
    this.objects = {};
  }
  _createClass(Registry, [{
    key: "add",
    value: function add(key, value) {
      if (_typeof(key) == 'object' && typeof value == 'undefined') {
        for (var index in key) {
          this._add(index, key[index]);
        }
      } else if (typeof key == 'string' && value) {
        this._add(key, value);
      } else {
        throw Error('Cannot add object to Registry, key or value is missing.');
      }
    }
  }, {
    key: "_add",
    value: function _add(key, value) {
      if (typeof this.objects[key] != 'undefined') {
        throw Error('Registry object with this key is already set.');
      }
      this.objects[key] = value;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      if (typeof this.objects[key] != 'undefined') {
        return true;
      }
      return false;
    }
  }, {
    key: "remove",
    value: function remove(key, value) {
      if (typeof this.objects[key] == 'undefined') {
        throw Error('Registry object with this key is not set.');
      }
      delete this.objects[key];
    }
  }, {
    key: "get",
    value: function get(key) {
      if (typeof this.objects[key] == 'undefined') {
        throw Error('Registry object with this key is not set.');
      }
      return this.objects[key];
    }
  }]);
  return Registry;
}();
var _instance;

/**
 * @return {Registry}
 */
function getInstance() {
  if (typeof document !== 'undefined') {
    if (!_instance) {
      _instance = new Registry();
      if (document.location) {
        var localeCode = document.location.pathname.includes('/en/') ? 'en' : 'fr';
        var locale = (0, _index.loadLocale)(localeCode);
        _instance.add({
          locale: locale
        });
      }
    }
    return _instance;
  }
}
var _default = getInstance();
exports["default"] = _default;